<template>
  <div class="convention-hall page" style="height: 100vh; overflow: hidden;">
    <van-nav-bar class="nav-bar" :title="$t('concubine.concubine')">
      <template #right>
        <van-image
          width="18"
          height="18"
          src="/img/clm.png"
          style="margin-right: 10px;"
								@click="isShow=false"
        />
        <van-image
          width="22"
          height="22"
          src="/img/row.png"
					@click="isShow=true"
        />
      </template>
    </van-nav-bar>
    <div class="banner-container">
      <swiper v-if="banners.length" class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="v.id || v.url || key">
          <van-image
            class="banner_img"
            :src="v.url"
            width="100%"
            height="160px"
          >
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
      <div v-else class="banner-loading">
        <van-loading type="circular" />
      </div>
    </div>

    <div style="flex: 1; background-color: #fff;">
      <van-tabs
        class="van-tabs"
        v-model="active"
        title-active-color="#C571CF"
        line-height="6px"
        line-width="31px"
      >
        <van-tab
          style="display:flex; align-items:stretch; height: calc(100vh - 260px);"
          :title="item.name"
          v-for="(item, index) in tabList"
          :key="index"
        >
          <div class="toupBox" style="height: 100%;">
            <van-sidebar v-model="activeSidebar" @change="onChangeSidebar">
              <van-sidebar-item :title="$t('index.all')" />
              <van-sidebar-item :title="$t('concubine.concubine') + '1'" />
              <van-sidebar-item :title="$t('concubine.concubine') + '2'" />
              <van-sidebar-item :title="$t('concubine.concubine') + '3'" />
              <van-sidebar-item :title="$t('concubine.concubine') + '4'" />
            </van-sidebar>
          </div>

          <div class="toupMain">
            <van-list
                v-model="loading"
                @load="onLoad"
                :offset="100"
                :finished="finished"
                finished-text="没有更多了"
                style="height: 100%; overflow-y: auto; -webkit-overflow-scrolling: touch;"
            >
              <!-- :finished="finished"
              finished-text="没有更多了" -->
              <div class="pblBox" v-show="!isShow">
                <div style="width: calc(50% - 5px);" v-for="item in data" :key="item.id" @click="toDetail(item.id)">
                  <div class="releaseItem">
                    <div class="imgBox">
                      <div class="van-image" style="width: 100%; height: 100%;">
                        <img
                            :src="item.img_url"
                            class="van-image__img"
                        />
                      </div>
                      <span><i>{{ $t('concubine.high_end') }}</i></span>
                      <div class="infoBox">
                        <i
                            class="van-icon van-icon-location"
                            style="font-size: 14px;"
                        ><!----></i
                        ><span
                          style="font-size: 12px; margin: 0px 0px 0px 2px;"
                      ></span>
                        <div class="wantyuebtn">{{ $t('concubine.appointment') }}</div>
                      </div>
                    </div>
                    <div class="tagBox" style="color: rgb(102, 102, 102);">
                      {{ $t('concubine.beautiful_girl') }}
                    </div>
                    <div class="di">
                      <div>
                      <span
                          style="
                          display: inline-block;
                          margin-right: 2px;
                          width: 12px;
                          height: 12px;
                          border-radius: 50%;
                          background: rgb(239, 186, 143);
                        "
                      ></span
                      ><span>{{ item.xuanfei_name }}</span>
                      </div>
                      <div>
                        <i
                            class="van-icon van-icon-like"
                            style="color: rgb(220, 99, 161);"
                        ><!----></i
                        ><span>{{ item.dianzan }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="horizontalItem" v-show="isShow" v-for="item in data" :key="item.id"  @click="toDetail(item.id)">
                <div  class="imgBox">
                  <div

                      class="van-image"
                      style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
                  >
                    <img
                        :src="item.img_url"
                        class="van-image__img"
                        style="object-fit: cover;"
                    />
                  </div>
                  <span ><i >{{ $t('concubine.high_end') }}</i></span>
                </div>
                <div  style="width: calc(100% - 140px);">
                  <div  class="top">
                    <div >
                      <div  class="van-image" style="width: 13px;">
                        <img
                            src="/img/vip.png"
                            style="width: 13px; height: 13px;"
                            class="van-image__img"
                        />
                      </div>
                      <span >{{$t("index.authentication")}}</span>
                    </div>
                    <div >
                      <div  class="van-image" style="width: 13px;">
                        <img
                            src="/img/vip.png"
                            class="van-image__img"
                            style="width: 13px; height: 13px;"
                        />
                      </div>
                      <span >{{$t("index.video_authentication")}}</span>
                    </div>
                    <div

                        style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
                    >
                      {{ item.xuanfei_name }}
                    </div>
                  </div>
                  <div  class="tags">
                    <van-tag
                        v-for="(tag, index) in item.flagArray"
                        :key="index"
                        :type="tagTypes[index]"
                    >
                      {{ tag }}
                    </van-tag>

                  </div>
                  <!----><!---->
                  <div  style="display: flex; align-items: center;">
              <span

                  style="font-size: 14px; color: rgb(102, 102, 102);"
              >{{$t("index.toll")}}：</span
              >
                    <van-rate v-model="item.number"   color="#ffd21e" size="20px" />
                  </div>
                  <div

                      style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
                  >

                    {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
                  </div>
                  <div  class="yueta">{{$t("index.about")}}</div>
                </div>
              </div>
            </van-list>

          </div>


        </van-tab>
      </van-tabs>
    </div>
		
  </div>
</template>

<script>
export default {
  data() {
    return {
		addlist: [],
		isShow:false,
      banners: [],
      configRetryTimer: null,
      basicData: [],
      active: 0,
      activeSidebar: 0, // 默认选中第一个（全部）
      tabList: [],
      data: [], // 当前显示的数据
      fullData: [], // 完整的数据列表
      page: 0,
		ids: 1,
		tagTypes: ['primary', 'success', 'danger', 'warning'],
      finished: false,
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        observer: true,
        observeParents: true,
        page: 0,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  methods: {
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: this.ids, page: this.page },
      }).then((res) => {
			// 保存完整数据
			this.fullData = res.data;
        const lanng = localStorage.getItem("lang");
			this.fullData.forEach(item => {
				const parts = item.flag.split('|')
			
          lanng == 'zh'? item.flag = parts[0]:lanng == 'en'? item.flag = parts[1]: lanng == 'ja'?item.flag = parts[2]:item.flag = parts[3]
          item.flagArray = item.flag.split('，');
         
			})
			console.log(this.fullData, 900)
        
			// 初始化时显示全部数据
			this.data = this.fullData;
      });
    },
		onLoad() {
        // 模拟加载延迟
        setTimeout(() => {
          // 这里可以添加实际的加载更多数据的逻辑
          this.loading = false;
          // 如果没有更多数据了，设置finished为true
          // this.finished = true;
        }, 1000);
      },
      // 根据选中的侧边栏项切换列表内容
      onChangeSidebar(index) {
        // 设置activeSidebar以确保选中状态正确
        this.activeSidebar = index;
        
        // 在现有列表上分割数据，不重新请求接口
        if (index === 0) {
          // 选中"全部"时，显示所有数据
          this.data = this.fullData;
        } else {
          // 选中具体窗口时，根据索引分割数据
          // 计算每个窗口应显示的数据量
          const totalItems = this.fullData.length;
          const itemsPerWindow = Math.ceil(totalItems / 4); // 假设平均分配到4个窗口
          
          // 根据索引计算当前窗口的数据范围
          const startIndex = (index - 1) * itemsPerWindow;
          const endIndex = index * itemsPerWindow;
          
          // 分割数据并显示当前窗口的数据
          this.data = this.fullData.slice(startIndex, endIndex);
        }
      },
		toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        this.tabList = res.data[0];

        this.tabList.forEach((item) => {
          item.name = item.name.split(",")[0];
        });
      });
    },
    getBasicConfig(attempt = 0) {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        const data = res && res.code === 200 && res.data && typeof res.data === "object"
          ? res.data
          : null;

        if (!data) {
          if (attempt < 2) {
            this.configRetryTimer = setTimeout(() => {
              this.getBasicConfig(attempt + 1);
            }, (attempt + 1) * 1000);
          }
          return;
        }

        this.basicData = data;
        this.getBanner(data);
      });
    },
    getBanner(data) {
      this.banners = Array.isArray(data.banners)
        ? data.banners.filter((banner) => banner && banner.url)
        : [];
    },
  },
  created() {
    this.getAddress();
    this.getBasicConfig();
    this.getxuanfeilist();
  },
  beforeDestroy() {
    clearTimeout(this.configRetryTimer);
  },
};
</script>

<style lang="less" scoped>
.banner-container {
  height: 160px;
  flex-shrink: 0;
}
.banner-loading {
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}
.nav-bar {
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
  height: 100px;
}
.van-nav-bar {
  line-height: 50px;
}
::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #ffffff;
  font-size: 35px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
.van-sidebar {
  width: 180px;
}
// /deep/ .van-col{
// padding: 30px 0px;
// }
.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  background: #f2f2f5;
  height: 100vh;
}
::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
}
::v-deep .van-tabs__line {
  background-color: #c571cf;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}

/deep/ .van-cell {
  padding: 30px 22px;
  font-size: 30px;
  line-height: 30px;
}
.pblBox {
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
  flex-wrap: wrap;
}
.releaseItem {
  width: 100%;
  margin-bottom: 30px;
}
.releaseItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  height: 49vw;
}
.tagBox {
  font-size: 3vw;
  margin: 10px 0;
}
.di {
  display: flex;
  justify-content: space-between;
  font-size: 3vw;
  color: #666;
}
.releaseItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.releaseItem .imgBox span i {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.releaseItem .imgBox .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 8vw;
  padding: 0 20px;
}
.releaseItem .imgBox .infoBox .wantyuebtn {
  border: 2px solid #fff;
  padding: 10px 16px;
  border-radius: 16px;
  opacity: 0.9;
  font-size: 3vw;
  margin-left: auto;
}

.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.horizontalItem .imgBox span {
  position: absolute;
  z-index: 9;
  background-color: #ebcaaf;
  color: #8d684b;
  transform: rotate(45deg);
  width: 20vw;
  height: 20vw;
  top: -11vw;
  right: -11vw;
}
.horizontalItem .imgBox i {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: 700;
  font-size: 4vw;
}
.top {
  display: flex;
}

.toupBox{
  background: white;
  
  a {
    line-height: 50px;
    font-size: 24px;
  }
}

/* 增加选择器优先级以确保样式生效 */
/* 使用不同的深度选择器写法 */
:deep(.van-sidebar-item) {
  text-align: center;
  background-color: white;
}

::v-deep .van-sidebar-item--select {
  background: rgba(0, 0, 0, 0.04); // 换成你想要的颜色
  
  .van-sidebar-item__text {
    color: #C571CF !important;
  }
}

::v-deep .van-sidebar-item--select::before {
  height: 6vw;
  width: 5px;
  left: 5px;
  background: linear-gradient(90deg, #c571cf, #7d76ef); // 换成你想要的颜色
}


.toupMain{
  flex:1;                /* 占剩余全部 */
  background:#fff;
  overflow: hidden;       /* 隐藏自身滚动条，让van-list处理滚动 */
  height: 100%;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding-bottom: 100px;
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
